module.exports = __webpack_public_path__ + "assets/img/media_18.5d0e8bc5.png";